module.exports = __webpack_public_path__ + "static/media/MoreWaysToEarnDefault.24cee66b.png";